import { Component, ElementRef, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-supplier',
  template: `
    <ng-template #modalSupplier let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">modal-supplier works!</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      </div>
    </ng-template>
  `,
  styles: [
  ]
})
export class ModalSupplierComponent {
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalSupplier') modalSupplier !: ElementRef;

  private modalRef: NgbModalRef | undefined;

  constructor(
    private modalService: NgbModal
  ) { }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
